/**
 * @file DataContext class is used when a detail overlay is created to support partial cancellation of the change set.
 * @author Tom Verschoore de la Houssaije
 */
/**
 * DataContext class is used when a detail overlay is created to support partial cancellation of the change set.
  * @export
 * @class DataContext
 */
var DataContext = /** @class */ (function () {
    /**
     * Creates an instance of DataContext.
     * @param {EntityManager} entityManager The entity manager of the domain.
     */
    function DataContext(entityManager) {
        this.entityManager = entityManager;
        this.previousChanges = entityManager.getChanges();
    }
    /**
     * Rejects the changes of this data context.
     */
    DataContext.prototype.rejectChanges = function () {
        var _this = this;
        var currentChanges = this.entityManager.getChanges();
        var contextChanges = [];
        currentChanges.forEach(function (entity) {
            if (_this.previousChanges.find(function (item) { return entity === item; }) == null) {
                // Change not found in previous change set thus mine change.
                if (entity.entityAspect.isBeingSaved) {
                    throw new Error('Can not reject changes of entity that is being saved.');
                }
                contextChanges.push(entity);
            }
        });
        contextChanges.forEach(function (entity) { return entity.entityAspect.rejectChanges(); });
    };
    return DataContext;
}());
export { DataContext };
